<script setup>
const emit = defineEmits(['update:open'])
const props = defineProps({
  offsetLeft: {
    type: String,
    default: '',
    required: false
  },
  open: {
    type: Boolean,
    default: false,
    required: false
  }
})

const refPop = ref(null)
const slots = useSlots()
const isHasIcon = computed(() => !!slots?.icon)

function handleFocusOut(e) {
  let isOutSide = !e.target.className.toString().includes('dropdown-overlay')

  if (!isOutSide) {
    emit('update:open', false)
  }
}

watch(
  () => refPop.value,
  (newValue, oldValue) => {
    if (newValue) {
      newValue.style.left = props.offsetLeft || 0
      // newValue.focus()
    }
  },
  { deep: true }
)
</script>

<template>
  <div class="relative inline-block text-left">
    <div @click="emit('update:open', !open)" class="flex flex-row items-center">
      <slot name="trigger"></slot>
      <slot v-if="isHasIcon" name="icon"></slot>
    </div>

    <div
      @click="handleFocusOut"
      tabindex="0"
      v-if="open"
      ref="refPop"
      :key="offsetLeft"
      :class="`
       absolute
        dropdown-overlay
        z-50
        mt-2
        w-auto
        origin-top-right
        rounded-md
        bg-white
        shadow-lg
        ring-1 ring-black ring-opacity-5
        focus:outline-none`"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style lang="scss">
.hover-link-profile {
  @apply hover:mx-2 hover:px-2;

  &:hover {
    background: #f2f7fe;
    border-radius: 3px;
    color: #0366eb;
    svg {
      path {
        fill: #0366eb;
      }
    }
  }
}

.dropdown-overlay {
  &::before {
    content: '';
    position: fixed;
    // background: #00000050;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
}
</style>
